import React from "react";
import PropTypes from "prop-types";
import TextField from '@material-ui/core/TextField';
import Typography from "@material-ui/core/Typography";
import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/AddCircleOutline";
import RemoveIcon from "@material-ui/icons/RemoveCircleOutline";
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(theme => ({
  select:{
      fontSize: '0.75rem',
  },
  formControl: {
    minWidth: 120,
    maxWidth: 300,
    margin: '0px',
    marginTop: '16px'
  },
  typography: {
    color: 'rgba(0, 0, 0, 0.54)',
    padding: 0,
    fontSize: '1rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: 'translate(0, 1.5px) scale(0.75)',
    transformOrigin: 'top left',
    letterSpacing: '0.00938em',
    transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
  }
}));

const Preferences = ({
  onChange,
  disabled,
  error,
  title,
  title_not_preferences,
  preferences,
  not_preferences,
  providers,
  removeItem,
  addNewItem,
  onProvidersSearch,
  ...props
}) => {

  const handleChange = event => {
    onChange(event, 'preferences')
  }

  const handleChangeNotPreferences = event => {
    onChange(event, 'not_preferences')
  }
  const handleAddItem = event => {
    event.preventDefault();
    event.stopPropagation();
    addNewItem('provider_ids');
  }

  const handleRemoveItem = (event, idx) =>{
    event.preventDefault();
    event.stopPropagation();
    removeItem('provider_ids', idx)
  }

  const handleAddItemNotPreferences = event => {
    event.preventDefault();
    event.stopPropagation();
    addNewItem('provider_ids_not_preferences');
  }

  const handleRemoveItemNotPreferences = (event, idx) =>{
    event.preventDefault();
    event.stopPropagation();
    removeItem('provider_ids_not_preferences', idx)
  }

  const classes = useStyles();

  const getProviderData = (id) => {
    if (id !== '' && id !== undefined && id !== null){
      var data = {}
      providers.map((val, idx)=>{
        if (parseInt(val.id) === parseInt(id)) {
          data.business_name = val.business_name
          data.fantasy_name = val.fantasy_name
        } 
      })
    }

    return data; 
  }

  const handleProvidersAsyncChange = (event, values) =>{
    event.target.value = values.id
    event.target.name = event.target.id
    onChange(event, 'preferences')
  }

  const handleProvidersNotPreferredAsyncChange = (event, values) =>{
    event.target.value = values.id
    event.target.name = event.target.id
    onChange(event, 'not_preferences')
  }

  const handleProvidersAsyncSearch = (event, values) =>{
    onProvidersSearch(values)
  }



  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {title}
      </Typography>

      {preferences.provider_ids.map((val, idx)=>{
        var data = ''
/*        if (preferences.provider_ids[idx].provider_id !== '' && preferences.provider_ids[idx].provider_id !== null && preferences.provider_ids[idx].provider_id !== undefined){
          data = getProviderData(preferences.provider_ids[idx].provider_id)
        }
*/
        return (
          <React.Fragment>
            <div className="row ml-1">
              {(preferences.provider_ids[idx].provider_id === '') ?
                /*<FormControl className="mr-2" style={{minWidth: 150, fontSize: '0.75rem'}} name={"provider_id."+ idx} >
                  <InputLabel htmlFor="grouped-native-select" autoWidth="true" style={{minWidth: 150, fontSize: '0.75rem'}} >Seleccione el proveedor</InputLabel>
                  <Select native name={"provider_id."+ idx}
                      inputProps={{
                        name:"provider_id."+ idx,
                        className:"provider_id."+ idx
                      }}
                      style={{minWidth: 150, fontSize: '0.75rem'}}
                      disabled={disabled}
                      onChange={handleChange}
                      error={(error !=='' && preferences.provider_id ==='') ? 'Debe completar este campo' :  false }
                      value={preferences.provider_ids[idx].provider_id}
                      input={<Input id="grouped-native-select" name={"provider_id."+ idx} />}>
                      <option value="" />
                      {[].map((provider) => <option id={provider.id} value={provider.id}>{provider.contact.hansa_code} - {provider.business_name} - {provider.fantasy_name}
                    </option>)}
                  </Select> 
                </FormControl>*/
                <Autocomplete
                  id={"provider_id."+ idx}
                  style={{ width: 200 }}
                  getOptionLabel={(option) => option.business_name}
                  getOptionSelected={(option, value) => option.business_name === value}           
                  options={providers.options}
                  loading={providers.loading}
                  onInputChange={handleProvidersAsyncSearch}
                  onChange={handleProvidersAsyncChange.bind(this)}
                  //value={this.state.providers.options.find(v => v.business_name === this.state.providers.provider.business_name) || {}}
                  autoComplete
                  noOptionsText={<Typography variant="caption">Sin resultados</Typography>}
                  name={"provider_id."+ idx}
                  includeInputInList
                  className="mt-3 mr-2"
                  classes={{
                      option: classes.option,
                    }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Ingrese un proveedor"
                      name={"provider_id."+ idx}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {providers.loading ? <CircularProgress color="inherit" size={20} /> : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                  InputLabelProps={{ ...params.InputLabelProps,
                            shrink: true
                          }}
                  inputProps={{
                              ...params.inputProps,
                              style:{fontSize: '0.75rem', width: 70}
                            }}

                    />
                  )}
                />

              :
                <TextField
                  id={"provider_id."+ idx}
                  name={"provider_id."+ idx}
                  label="Proveedor"
                  disabled={true}
                  type="text"
                  value={preferences.provider_ids[idx].business_name}
                  margin="normal"
                  className="mr-2 "
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
                />
              }
              <div class="mt-4" style={{width:"min-content", display:"inline-flex"}}>   

                <IconButton size="small" className={classes.iconButton} onClick={(e)=> {handleRemoveItem(e, idx)}}
                disabled={(preferences.provider_ids.length ==1) ? true : false} >
                  <RemoveIcon className={classes.deleteIcon} />
                </IconButton>
                <IconButton size="small" className={classes.iconButton} onClick={(e)=> {handleAddItem(e)}}>
                      <AddIcon className={classes.deleteIcon}/>
                </IconButton>
              </div>
            </div>
          </React.Fragment>
        )
      })
      }

      <Typography variant="h6" className="mt-2">{title_not_preferences}</Typography>

      {not_preferences.provider_ids.map((val, idx)=>{
/*        var data = ''
        if (not_preferences.provider_ids[idx].provider_id !== '' && not_preferences.provider_ids[idx].provider_id !== null && not_preferences.provider_ids[idx].provider_id !== undefined){
          data = getProviderData(not_preferences.provider_ids[idx].provider_id)
        }
*/
        return (
          <React.Fragment>

            <div className="row ml-1">
              {(not_preferences.provider_ids[idx].provider_id === '') ?
                /*<FormControl className="mr-2" style={{minWidth: 150, fontSize: '0.75rem'}} name={"provider_id."+ idx} >
                  <InputLabel htmlFor="grouped-native-select" autoWidth="true" style={{minWidth: 150, fontSize: '0.75rem'}} >Seleccione el proveedor</InputLabel>
                  <Select native name={"provider_id."+ idx}
                      inputProps={{
                        name:"provider_id."+ idx,
                        className:"provider_id."+ idx
                      }}
                      style={{minWidth: 150, fontSize: '0.75rem'}}
                      disabled={disabled}
                      onChange={handleChangeNotPreferences}
                      error={(error !=='' && not_preferences.provider_id ==='') ? 'Debe completar este campo' :  false }
                      value={not_preferences.provider_ids[idx].provider_id}
                      input={<Input id="grouped-native-select" name={"provider_id."+ idx} />}>
                      <option value="" />
                      {[].map((provider) => <option id={provider.id} value={provider.id}>{provider.contact.hansa_code} - {provider.business_name} - {provider.fantasy_name}
                    </option>)}
                  </Select> 
                </FormControl>
              */

                <Autocomplete
                  id={"provider_id."+ idx}
                  style={{ width: 200 }}
                  getOptionLabel={(option) => option.business_name}
                  getOptionSelected={(option, value) => option.business_name === value}           
                  options={providers.options}
                  loading={providers.loading}
                  onInputChange={handleProvidersAsyncSearch}
                  onChange={handleProvidersNotPreferredAsyncChange.bind(this)}
                  //value={this.state.providers.options.find(v => v.business_name === this.state.providers.provider.business_name) || {}}
                  autoComplete
                  noOptionsText={<Typography variant="caption">Sin resultados</Typography>}
                  name={"provider_id."+ idx}
                  includeInputInList
                  className="mt-3 mr-2"
                  classes={{
                      option: classes.option,
                    }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Ingrese un proveedor"
                      name={"provider_id."+ idx}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {providers.loading ? <CircularProgress color="inherit" size={20} /> : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                  InputLabelProps={{ ...params.InputLabelProps,
                            shrink: true
                          }}
                  inputProps={{
                              ...params.inputProps,
                              style:{fontSize: '0.75rem', width: 70}
                            }}

                    />
                  )}
                />

              :
                <TextField
                  id={"provider_id."+ idx}
                  name={"provider_id."+ idx}
                  label="Proveedor"
                  disabled={true}
                  type="text"
                  value={not_preferences.provider_ids[idx].business_name}
                  margin="normal"
                  className="mr-2 "
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
                />
              }
              <div class="mt-4" style={{width:"min-content", display:"inline-flex"}}>   

                <IconButton size="small" className={classes.iconButton} onClick={(e)=> {handleRemoveItemNotPreferences(e, idx)}}
                disabled={(not_preferences.provider_ids.length ==1) ? true : false} >
                  <RemoveIcon className={classes.deleteIcon} />
                </IconButton>
                <IconButton size="small" className={classes.iconButton} onClick={(e)=> {handleAddItemNotPreferences(e)}}>
                      <AddIcon className={classes.deleteIcon}/>
                </IconButton>
              </div>
            </div>
          </React.Fragment>
        )
      })
      }
  	</React.Fragment>
  	)
}
export default Preferences;
